import React from 'react'

export const Nl2Br = ({ children }: { children: string }): React.ReactNode => (
    <React.Fragment>
        {children.split('\n').map((v, i, parts) => (
            <React.Fragment key={i}>
                {v}
                {i < parts.length - 1 && <br />}
            </React.Fragment>
        ))}
    </React.Fragment>
)
